/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PageableObject } from './PageableObject';
import {
    PageableObjectFromJSON,
    PageableObjectFromJSONTyped,
    PageableObjectToJSON,
    PageableObjectToJSONTyped,
} from './PageableObject';
import type { JobDTO } from './JobDTO';
import {
    JobDTOFromJSON,
    JobDTOFromJSONTyped,
    JobDTOToJSON,
    JobDTOToJSONTyped,
} from './JobDTO';
import type { SortObject } from './SortObject';
import {
    SortObjectFromJSON,
    SortObjectFromJSONTyped,
    SortObjectToJSON,
    SortObjectToJSONTyped,
} from './SortObject';

/**
 * 
 * @export
 * @interface PageJobDTO
 */
export interface PageJobDTO  {
    /**
     * 
     * @type {number}
     * @memberof PageJobDTO
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof PageJobDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageJobDTO
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {SortObject}
     * @memberof PageJobDTO
     */
    sort?: SortObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageJobDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageJobDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageJobDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageJobDTO
     */
    size?: number;
    /**
     * 
     * @type {Array<JobDTO>}
     * @memberof PageJobDTO
     */
    content?: Array<JobDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageJobDTO
     */
    number?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageJobDTO
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the PageJobDTO interface.
 */
export function instanceOfPageJobDTO(value: object): value is PageJobDTO {
    return true;
}

export function PageJobDTOFromJSON(json: any): PageJobDTO {
    return PageJobDTOFromJSONTyped(json, false);
}

export function PageJobDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageJobDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
                  'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
                  'pageable': json['pageable'] == null ? undefined : PageableObjectFromJSON(json['pageable']),
                  'sort': json['sort'] == null ? undefined : SortObjectFromJSON(json['sort']),
                  'first': json['first'] == null ? undefined : json['first'],
                  'last': json['last'] == null ? undefined : json['last'],
                  'numberOfElements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
                  'size': json['size'] == null ? undefined : json['size'],
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(JobDTOFromJSON)),
                  'number': json['number'] == null ? undefined : json['number'],
                  'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function PageJobDTOToJSON(json: any): PageJobDTO {
    return PageJobDTOToJSONTyped(json, false);
}

export function PageJobDTOToJSONTyped(value?: PageJobDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'totalPages': value['totalPages'],
        'totalElements': value['totalElements'],
        'pageable': PageableObjectToJSON(value['pageable']),
        'sort': SortObjectToJSON(value['sort']),
        'first': value['first'],
        'last': value['last'],
        'numberOfElements': value['numberOfElements'],
        'size': value['size'],
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(JobDTOToJSON),
        'number': value['number'],
        'empty': value['empty'],
    };
}


